import { retrieve, update } from "framework/http/endpoint";
import { createEntityResponseFactory } from "framework/http/rest/jsonResponse";
import { createEntityRequest } from "framework/http/rest/jsonRequest";
import { UrlPathOfApiLocation } from "common/paths";
var ApiUriPrefix = "".concat(UrlPathOfApiLocation, "/api/1/");
var CompetitorsApiUri = ApiUriPrefix + "competitors";
function apiGetComponentCompetitors(groupCompetitorId, competitionId) {
    var uri = "".concat(CompetitorsApiUri, "/").concat(groupCompetitorId, "/components/").concat(competitionId);
    return retrieve(uri, null, createEntityResponseFactory(fromTransportComponentCompetitors));
}
function apiUpdateComponentCompetitors(competitorId, competitionId, componentCompetitors, captain) {
    var uri = "".concat(CompetitorsApiUri, "/").concat(competitorId, "/components/").concat(competitionId);
    var entity = {
        competitorId: competitorId,
        competitionId: competitionId,
        captain: captain,
        components: componentCompetitors
    };
    var transport = intoTransportComponentCompetitors(entity);
    var request = createEntityRequest(transport);
    return update(uri, request, createEntityResponseFactory(fromTransportComponentCompetitors));
}
function fromTransportComponentCompetitors(entity) {
    var result = JSON.parse(JSON.stringify(entity));
    return result;
}
function intoTransportComponentCompetitors(entity) {
    var result = JSON.parse(JSON.stringify(entity));
    return result;
}
export { apiGetComponentCompetitors, apiUpdateComponentCompetitors, };
